<template>
    <v-divider 
        opacity="1" 
        thickness="1">
        {{ title }}
    </v-divider>
</template>

<script>
export default {
    name: 'SideTitle',
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style>
.v-divider__wrapper {
    margin-bottom: 20px;
    font-size: 1.0rem; 
    color: rgb(var(--v-theme-secondary)) !important;
}
</style>